export const USER_ROLES = {
  SKEFTO_ADMIN: 'SKEFTO_ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN'
}

export const USER_GENDER = {
  Male: 'MALE',
  Female: 'FEMALE',
  Other: 'OTHER'
}

export const USER_GENDER_OPTIONS = [
  {
    label: 'Male',
    value: USER_GENDER.Male
  },
  {
    label: 'Female',
    value: USER_GENDER.Female
  },
  {
    label: 'Other',
    value: USER_GENDER.Other
  }
]

const EMPLOYMENT_STATUS = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME'
}

export const EMPLOYMENT_STATUS_OPTIONS = [
  {
    label: 'Full Time',
    value: EMPLOYMENT_STATUS.FULL_TIME
  },
  {
    label: 'Part Time',
    value: EMPLOYMENT_STATUS.PART_TIME
  }
]

export const AUTH_METHODS = {
  SSO: 'SSO',
  NO_LOGIN: 'NO_LOGIN',
  APPLICATION_METHOD: 'APPLICATION_METHOD',
}

export const AUTH_METHOD_OPTIONS = [
  {
    label: 'Single Sign-On',
    value: AUTH_METHODS.SSO
  },
  {
    label: 'No Login',
    value: AUTH_METHODS.NO_LOGIN
  },
  {
    label: 'Application Method',
    value: AUTH_METHODS.APPLICATION_METHOD
  },
]
